import React from 'react';
import { createRoot } from 'react-dom/client';
import { PageProvider } from '~/providers';
import SignInPage from '~envs/pages/signin';

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <PageProvider pageTag="signin">
        <SignInPage />
    </PageProvider>
);
